import React from 'react';

import {FormControl, HStack, Switch} from 'native-base';
import {defaultProps} from '../../../../../../../components/inputs/constants';
import {message as t} from '../../../../../../../utils/messages';

const SwitchInput = ({
  value,
  label,
  onToggle,
}: {
  value: boolean;
  label: string;
  onToggle?: (value: boolean) => void;
}) => {
  const handleToogle = (toogleValue: boolean) => {
    if (onToggle) {
      onToggle(toogleValue);
    }
    //  setValue('requestTransportQuote', toogleValue);
  };

  return (
    <HStack marginBottom={5}>
      <FormControl justifyContent={'space-between'} flexDir={'row'}>
        <FormControl.Label>{t(label)}</FormControl.Label>
        <Switch
          {...defaultProps}
          size="sm"
          offTrackColor="#EFEFEF"
          onTrackColor="#0088FF"
          onThumbColor="#FFFFFF"
          offThumbColor="#FFFFFF"
          value={value}
          onToggle={handleToogle}
        />
      </FormControl>
    </HStack>
  );
};

export default SwitchInput;
